import { useState, useEffect } from 'react';
import { Header, Table, Icon } from 'semantic-ui-react';
import * as Collapsible from '@radix-ui/react-collapsible';
import toast from 'react-hot-toast';

import Button from '~/components/Button';
import Modal from '~/components/Modal';
import { indexRfisByProjectId, indexRfisByPortfolioId } from '~/api/requestForInformation';
import { useProjectContext, usePortfolioContext } from '~/hooks';
import RfiRow from './RfiRow';
import RfiForm from './RfiForm';
import '../styles.scss';

const RfiTable = () => {

  const [isExpanded, setIsExpanded] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [rfiToEdit, setRfiToEdit] = useState<any>(null); // TODO: type for this
  const iconName = isExpanded ? 'caret down' : 'caret right';
  const [rfis, setRfis] = useState<any>(); // TODO: type for this
  const { project } = useProjectContext();
  const { portfolio } = usePortfolioContext();

  useEffect(() => {
    if (portfolio) {
      getPortfolioRfis();
    } else {
      getProjectRfis();
    }
    setRfiToEdit(null);
  }, []);

  const refreshList = () => {
    if (portfolio) {
      getPortfolioRfis();
    } else {
      getProjectRfis();
    }
  };

  const getPortfolioRfis = () => {
    if (portfolio?.id) {
      indexRfisByPortfolioId(portfolio.id).then(setRfis).catch((error: any) => {
        toast.error('Failed to load RFIs');
      });
    }
  };

  const getProjectRfis = () => {
    if (project?.id) {
      indexRfisByProjectId(project.id).then(setRfis).catch((error) => {
        toast.error('Failed to load RFIs');
      });
    }
  };

  const handleEdit = (rfi: any) => {
    setRfiToEdit(rfi);
    setModalIsOpen(true);
  };

  const handleCreate = () => {
    setRfiToEdit(null);
    setModalIsOpen(true);
  };

  return (
    <>
      {!project?.portfolioId && (
        <div className="rfi-container card" >

          <Collapsible.Root open={isExpanded} onOpenChange={() => setIsExpanded(!isExpanded)}>
            <Collapsible.Trigger className="investor-queue-header">
              <Icon name={iconName} />
              <Header as='h2' style={{ margin: '0' }}>Requests for Information</Header>
            </Collapsible.Trigger>
            <Collapsible.Content className="CollapsibleContent rfi-content">
              <p><strong>Pro Tip:</strong> Send all RFIs for a portfolio or project prior to inviting investors.</p>

              {rfis && rfis.length > 0 && (
                <Table basic compact className="rfi-table">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell color='grey'>Name</Table.HeaderCell>
                      <Table.HeaderCell color='grey'>Description</Table.HeaderCell>
                      <Table.HeaderCell color='grey'>Status</Table.HeaderCell>
                      <Table.HeaderCell color='grey' textAlign="center">Actions</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {rfis && rfis.map((rfi: any) => (
                      <RfiRow key={rfi.id} rfi={rfi} refreshList={refreshList} edit={handleEdit} />
                    ))}
                  </Table.Body>
                </Table>
              )}


              <Button primary onClick={handleCreate}>
                <Icon name='plus' />
                Add request for information
              </Button>

              {modalIsOpen &&
                (
                  <Modal closeModal={() => setModalIsOpen(false)}>
                    <Modal.Title>
                      {rfiToEdit ? 'Edit' : 'Create'} request for information
                    </Modal.Title>
                    <Modal.Content>
                      <RfiForm
                        rfiToEdit={rfiToEdit}
                        refreshList={refreshList}
                        closeModal={() => setModalIsOpen(false)}
                      />
                    </Modal.Content>
                  </Modal>
                )
              }
            </Collapsible.Content>
          </Collapsible.Root>
        </div >
      )
      }
    </>
  );
};

export default RfiTable;